import { FC, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'app/lang';
import useComponentWillMount from 'app/lib/hooks/useComponentWillMount';
import { fetchPrematchCategories } from 'app/modules/Prematch/actions';
import { useComponentWillReceiveProps } from 'app/packages/lib/hooks';

import { requested } from '../../selectors/prematch';

export const PrematchMenuLoader: FC = memo(() => {
  const dispatch = useDispatch();
  const { lang } = useTranslation();

  const prematchRequested = useSelector(requested);

  useComponentWillMount(() => {
    if (!prematchRequested) {
      dispatch(fetchPrematchCategories());
    }
  });

  useComponentWillReceiveProps(() => {
    dispatch(fetchPrematchCategories());
  }, [lang]);

  return null;
});
